<template>
  <div class="page-container">
    <!--工具栏-->
    <div class="toolbar">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="">
          <el-select
            v-model="form.operationStaffName"
            placeholder="操作员"
            filterable
            clearable
          >
            <el-option
              v-for="item in operatorList"
              :key="item.staffId"
              :value="item.name"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="form.operationTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="修改开始"
            end-placeholder="修改结束"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="handleSearch()"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
    </div>
    <el-table
      v-loading="loading"
      :data="logList"
      stripe
      size="mini"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" fixed width="50">
      </el-table-column>
      <!-- <el-table-column prop="coalWarehouseNo" label="仓号"> </el-table-column> -->
      <el-table-column prop="operationTime" label="修改时间"> </el-table-column>
      <el-table-column prop="operationResult" label="内容"> </el-table-column>
      <el-table-column prop="operationStaffName" label="操作员">
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";

export default {
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      loading: false,
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      operationModule: 4,
      form: {
        operationStaffName: "", // 操作员
        operationTime: "",
      },
      operatorList: [],
      // 表格数据
      logList: [],
    };
  },
  mounted() {
    this.getLogList();
    this.getSelectByCoalMineNo();
  },
  methods: {
    getLogList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        operationModule: this.operationModule,
        coalMineNo: this.coalMineNo,
      };
      const form = { ...this.form };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "operationTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.coalModel.getLogList(params).then((res) => {
        if (res.code === "0") {
          if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
            this.logList = res.data.dtoList;
          } else {
            this.logList = [];
          }
          this.totalSize = res.data.totalSize || 0;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message({
            message: "查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getLogList();
    },
    // 重置
    handleReset() {
      this.form = {
        operationStaffName: "", // 操作员
        operationTime: "",
      };
      this.handleSearch();
    },
    getReturn() {
      this.$router.push({
        path: "/apply/particulars",
      });
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getLogList();
    },
    // 根据煤矿编号查询操作人员
    getSelectByCoalMineNo() {
      this.$api.system.mSelectCoalMineNoStaff({coalMineNo: this.coalMineNo}).then((res) => {
        if (res.data && res.data.length > 0) {
          this.operatorList = res.data;
        } else {
          this.operatorList = [];
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.page_title_desc {
  cursor: pointer;
}
</style>
